// Demirbaşların müşteri/proje bağı ve sahiplik türü için ortak tanımlar.

// Demirbaş bir müşteri yerine firmanın kendisine de bağlanabilir. Bu değer
// Stocks.customerName alanına yazılır; Customers koleksiyonunda karşılığı yoktur.
export const OWN_COMPANY_NAME = 'HABCARE CRO';

export const isOwnCompany = (customerName) => customerName === OWN_COMPANY_NAME;

// Stocks.ownershipType — demirbaş kimin malı / hangi koşulla elimizde?
export const OWNERSHIP_TYPES = [
  { value: 'owned', label: 'Firma Malı (Bizim)' },
  { value: 'rented', label: 'Kiralık' },
  { value: 'customer', label: 'Müşteriye Ait' },
  { value: 'loaned', label: 'Emanet / Ödünç' },
  { value: 'other', label: 'Diğer' },
];

export const getOwnershipLabel = (value) =>
  OWNERSHIP_TYPES.find((type) => type.value === value)?.label || '';
